export default __webpack_public_path__ + "static/media/admin-logo1.275eb1f2.png";